export class ApiError extends Error {
  constructor(
    message: string,
    public statusCode?: number,
    public isAuthError = false
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/**
 * Wrap API calls with error handling
 */
export async function handleApiCall<T>(
  apiFunction: () => Promise<T>,
  errorMessage = 'An error occurred'
): Promise<T> {
  try {
    return await apiFunction();
  } catch (error) {
    console.error('API Error:', error);

    if (error instanceof ApiError) {
      // Already formatted error
      throw error;
    }

    if (error instanceof Error) {
      // Check for auth errors
      if (
        error.message.includes('Unauthorized') ||
        error.message.includes('Invalid token') ||
        error.message.includes('Token expired') ||
        error.message.includes('No authentication token') ||
        error.message.includes('401')
      ) {
        throw new ApiError('Session expired. Please login again.', 401, true);
      }

      // Other errors
      throw new ApiError(error.message || errorMessage);
    }

    throw new ApiError(errorMessage);
  }
}

/**
 * Display user-friendly error messages
 */
export function displayError(error: unknown): string {
  if (error instanceof ApiError) {
    return error.message;
  } else if (error instanceof Error) {
    return error.message;
  }
  return 'An unexpected error occurred. Please try again.';
}
